import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './layout/AppLayout';
import Dashboard from './dashboard/Dashboard';
import ApprovalQueue from './approvals/ApprovalQueue';
import RejectedImages from './analysis/RejectedImages';
import ErrorBoundary from './ErrorBoundary';

const MainApp: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="approvals" element={<ErrorBoundary><ApprovalQueue /></ErrorBoundary>} />
        <Route path="rejected" element={<RejectedImages />} />
        <Route path="approved" element={<ApprovedImages />} />
      </Route>
    </Routes>
  );
};

// Placeholder for approved images component
const ApprovedImages: React.FC = () => {
  return (
    <div className="approved-images">
      <div className="page-header">
        <h1>Approved Images</h1>
        <p className="page-subtitle">View images that have been approved for upload</p>
      </div>
      <div style={{
        padding: '2rem',
        backgroundColor: 'var(--color-surface)',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--color-border)',
        textAlign: 'center',
        color: 'var(--color-text-muted)'
      }}>
        <p>Approved images view coming soon...</p>
      </div>
    </div>
  );
};

export default MainApp;